// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2fVG4","title":"Header_title__2n_WV","side":"Header_side__2JrqE"};